<table class="w-full text-left rtl:text-right text-gray-500 bg-emerald-500">
	<thead class="text-white text-xs semi-bold top-0 z-10">
		<tr>
			<th class="px-2 py-2"></th>
			<th [sortableHeader]="sortColumns.NAME" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Name
				<i [class]="getSortIconClass(sortColumns.NAME)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.ADDRESS" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Address
				<i [class]="getSortIconClass(sortColumns.ADDRESS)" class="ml-1"></i>
			</th>

			<th [sortableHeader]="sortColumns.CITY" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2 cursor-pointer">
				City
				<i [class]="getSortIconClass(sortColumns.CITY)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.STATE" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				State
				<i [class]="getSortIconClass(sortColumns.STATE)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.PHONE" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Phone
				<i [class]="getSortIconClass(sortColumns.PHONE)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.REMOTE_NUMBER" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Remote #
				<i [class]="getSortIconClass(sortColumns.REMOTE_NUMBER)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.HOLD_UNIT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				Hold Unit
				<i [class]="getSortIconClass(sortColumns.HOLD_UNIT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.HOLD_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="fas fa-phone-volume"></i>
				<i [class]="getSortIconClass(sortColumns.HOLD_COUNT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.VIDEO_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="fas fa-tv"></i>
				<i [class]="getSortIconClass(sortColumns.VIDEO_COUNT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.POSTER_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="far fa-square"></i>
				<i [class]="getSortIconClass(sortColumns.POSTER_COUNT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.RADIO_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="fas fa-volume-up"></i>
				<i [class]="getSortIconClass(sortColumns.RADIO_COUNT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.WEB_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="fas fa-laptop"></i>
				<i [class]="getSortIconClass(sortColumns.WEB_COUNT)" class="ml-1"></i>
			</th>
			<th [sortableHeader]="sortColumns.VIDEO_WALL_COUNT" [currentSort]="sortConfig" (sort)="onSort($event)" class="px-2 py-2">
				<i class="fas fa-th"></i>
				<i [class]="getSortIconClass(sortColumns.VIDEO_WALL_COUNT)" class="ml-1"></i>
			</th>
		</tr>
	</thead>
	<tbody class="text-black">
		<tr
			*ngFor="let location of locationsService.locations | searchFilter : searchTerm | sortable : sortConfig : valueAccessor"
			class="bg-white border-b text-[12px] xl:text-sm"
		>
			<td class="py-2 px-2">
				<button
					(click)="onViewClick(location)"
					class="!w-auto text-black bg-gray-200 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-3 py-2.5 me-2"
				>
					View
				</button>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black semi-bold">{{ location.Name }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.Address1 }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.City }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.State }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.Phone }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.holdRemoteNumber }}</p>
			</td>
			<td class="py-2 px-2">
				<p class="flex items-center text-black">{{ location.holdUnit }}</p>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="fas fa-phone-volume"></i>
					<p class="text-black">{{ location.holdCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="fas fa-tv"></i>
					<p class="text-black">{{ location.videoCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="far fa-square"></i>
					<p class="text-black">{{ location.posterCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="fas fa-volume-up"></i>
					<p class="text-black">{{ location.radioCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="fas fa-laptop"></i>
					<p class="text-black">{{ location.webCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<div class="flex items-center gap-2">
					<i class="fas fa-th"></i>
					<p class="text-black">{{ location.videoWallCount }}</p>
				</div>
			</td>
			<td class="py-2 px-2">
				<button
					(click)="onDeleteClick(location)"
					class="!w-auto text-red-500 focus:outline-hidden hover:bg-gray-100 focus:ring-4 focus:ring-gray-100 font-medium rounded text-sm px-3 py-2.5 me-2"
				>
					<i class="far fa-trash-alt"></i>
				</button>
			</td>
		</tr>
	</tbody>
</table>
